import FaqBtn from './FaqBtn';
export default FaqBtn;
